export const DEFAULT_CRM_LEAD_SOURCES = [
  { value: 'manual', label: 'Manual Entry', isLocked: true },
  { value: 'website', label: 'Website', isLocked: true },
  { value: 'instagram', label: 'Instagram', isLocked: true },
  { value: 'referral', label: 'Referral', isLocked: true },
  { value: 'chat', label: 'Chat', isLocked: true },
  { value: 'from_email', label: 'From Email', isLocked: true },
  { value: 'facebook', label: 'Facebook', isLocked: true },
  { value: 'google', label: 'Google', isLocked: true },
  { value: 'other', label: 'Other', isLocked: true }
];

export const mergeLeadSources = (sources = []) => {
  const merged = new Map();
  DEFAULT_CRM_LEAD_SOURCES.forEach((source) => {
    merged.set(source.value, { ...source });
  });
  sources.forEach((source) => {
    const value = String(source?.value || '').trim();
    const label = String(source?.label || '').trim();
    if (!value || !label) return;
    merged.set(value, { ...source, value, label });
  });
  return Array.from(merged.values());
};

export const getLeadSourceLabel = (value, sources = DEFAULT_CRM_LEAD_SOURCES) => {
  const key = String(value || '').trim();
  if (!key) return 'Unknown';
  const source = (sources || []).find((item) => item.value === key);
  if (source?.label) return source.label;
  return key
    .split(/[_-]/g)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
};
